"use client";

import Link from "next/link";
import { useActionState } from "react";
import { login } from "./actions";

export function LoginForm({ callbackUrl }: { callbackUrl?: string }) {
  const action = login.bind(null, callbackUrl ?? null);
  const [error, formAction, pending] = useActionState(action, undefined);
  const registerHref = callbackUrl
    ? `/register?callbackUrl=${encodeURIComponent(callbackUrl)}`
    : "/register";

  return (
    <form action={formAction} className="space-y-5">
      <div>
        <label htmlFor="email" className="mb-1.5 block text-sm font-bold text-zinc-700">
          Email
        </label>
        <input
          id="email"
          name="email"
          type="email"
          required
          autoComplete="email"
          className="w-full rounded-xl border border-[#e0507a]/20 bg-white px-4 py-3 text-sm text-zinc-900 outline-none transition-colors placeholder:text-zinc-400 focus:border-[#e0507a] focus:ring-2 focus:ring-[#e0507a]/20"
        />
      </div>

      <div>
        <div className="mb-1.5 flex items-center justify-between">
          <label htmlFor="password" className="block text-sm font-bold text-zinc-700">
            Hasło
          </label>
          <Link href="/forgot-password" className="text-xs font-bold text-[#e0507a] hover:text-[#c9436a]">
            Zapomniałeś hasła?
          </Link>
        </div>
        <input
          id="password"
          name="password"
          type="password"
          required
          autoComplete="current-password"
          className="w-full rounded-xl border border-[#e0507a]/20 bg-white px-4 py-3 text-sm text-zinc-900 outline-none transition-colors placeholder:text-zinc-400 focus:border-[#e0507a] focus:ring-2 focus:ring-[#e0507a]/20"
        />
      </div>

      {error && (
        <p className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700" role="alert">
          {error}
        </p>
      )}

      <button
        type="submit"
        disabled={pending}
        className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#e8607a] px-8 py-3.5 text-sm font-bold uppercase tracking-widest text-white shadow-md transition-all hover:-translate-y-0.5 hover:bg-[#d4556e] disabled:pointer-events-none disabled:opacity-60"
      >
        {pending ? "Logowanie…" : "Zaloguj się"}
      </button>

      <p className="text-center text-sm text-zinc-600">
        Nie masz konta?{" "}
        <Link href={registerHref} className="font-bold text-[#e0507a] hover:text-[#c9436a]">
          Zarejestruj się
        </Link>
      </p>
    </form>
  );
}
